module.exports = __webpack_public_path__ + "static/img/rongyu.c4577fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rongyu.png
// module id = fJTC
// module chunks = 1